document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('product-card');

  cards.forEach((card) => {
    let autoplay = null;

    card.addEventListener('mouseenter', () => {
      const nextButton = card.querySelector(
        'button[aria-label*="Next"],' +
        'button[aria-label*="next"],' +
        'button[name="next"],' +
        '.slider-button--next'
      );

      if (!nextButton) return;

      autoplay = setInterval(() => {
        if (!nextButton.disabled) {
          nextButton.click();
        }
      }, 1000);
    });

    card.addEventListener('mouseleave', () => {
      clearInterval(autoplay);
      autoplay = null;
    });
  });
});